<template>
  <div>
    <v-row no-gutters>
      <v-col cols="12" md="6">
        <title-page title="List Review" />
      </v-col>
      <v-col cols="12" md="6">
        <div class="d-flex justify-end">
          <v-btn
            class="bg_default text-capitalize rounded-lg"
            depressed
            dark
            @click="createReview"
            >+ Add Review</v-btn
          >
        </div>
      </v-col>
    </v-row>
    <!--  ========================================================================= toolbar -->

    <v-card class="rounded_max mt-5" flat>
      <div class="pa-3">
        <v-card flat class="rounded-lg" color="#f6f6f6">
          <v-row no-gutters>
            <v-col cols="12" md="5">
              <div class="pa-2">
                <v-text-field
                  placeholder="Search Data"
                  solo
                  v-model="find"
                  @keyup="fetchData"
                  hide-details
                  dense
                  prepend-inner-icon="mdi-magnify"
                  flat
                ></v-text-field>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-select
                  dense
                  hide-details
                  :items="optStatus"
                  item-text="txt"
                  item-value="val"
                  v-model="status_draft"
                  @change="fetchData()"
                  placeholder="Filter Status"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-select
                  dense
                  hide-details
                  :items="optMonth"
                  item-text="txt"
                  item-value="val"
                  v-model="month"
                  @change="fetchData()"
                  placeholder="Filter Per Month"
                  flat
                  solo
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="2">
              <div class="pa-2">
                <v-menu
                  v-model="menuLimit"
                  bottom
                  :nudge-bottom="55"
                  elevation="0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      class="text-capitalize color_txt"
                      height="38px"
                      block
                      color="#fff"
                      v-bind="attrs"
                      v-on="on"
                      ><p class="default_txt">Show : {{ limit }}</p>
                      <v-icon>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>
                  <v-card class="popup_radius" outlined elevation="0">
                    <v-list>
                      <v-list-item link @click="changeLimit(10)">
                        <v-list-item-title>10</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(50)">
                        <v-list-item-title>50</v-list-item-title>
                      </v-list-item>
                      <v-list-item link @click="changeLimit(100)">
                        <v-list-item-title>100</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </div>
      <!--  ========================================================================= data table -->
      <div>
        <v-skeleton-loader
          type="table-tbody"
          v-if="loading"
        ></v-skeleton-loader>
        <div v-if="dataSet && !loading">
          <v-data-table
            :headers="headers"
            :items="dataSet"
            :page.sync="page"
            :items-per-page="limit"
            class="elevation-0 color_txt"
            hide-default-footer
            :single-select="false"
          >
            <template v-slot:[`item.status_draft`]="{ item }">
              <td>{{ item.status_draft == 1 ? "Draft" : "Publish" }}</td>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
              <div class="d-flex">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      fab
                      depressed
                      x-small
                      class="mr-2"
                      color="blue"
                      dark
                      @click="
                        item.status_draft == 1
                          ? updateReview(item)
                          : viewReview(item)
                      "
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View Review</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      fab
                      v-bind="attrs"
                      v-on="on"
                      depressed
                      x-small
                      color="red"
                      dark
                      @click="deleteReview(item)"
                    >
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Delete Data</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </v-card>
    <div class="text-center pa-3" v-if="dataSet">
      <v-pagination
        v-model="page"
        color="#006341"
        @input="fetchData"
        :length="last_page"
      ></v-pagination>
    </div>
    <div class="pa-2">
      <dialog-medium
        :d_create="d_create"
        @refetch="fetchData"
        @close="d_create = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
      <dialog-small
        :d_small="d_small"
        @refetch="fetchData"
        @close="d_small = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import TitlePage from "../../../components/atom/titlePage.vue";
// import dialogCreate from "../../dialog/dialogMedium.vue";
import DialogSmall from "../../dialog/dialogSmall.vue";
export default {
  name: "mentorReview",
  components: { 
    // dialogCreate, 
    TitlePage, DialogSmall },
  data() {
    return {
      dataSet: null,
      loading: false,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      status_draft: "",
      d_create: false,
      d_small: false,
      inventory: null,
      d_type: "",
      d_title: "",
      menuLimit: false,
      month: "",
      find: "",
      optStatus: [
        { txt: "Publish", val: 0 },
        { txt: "Draft", val: 1 },
        { txt: "All", val: "" },
      ],
      optMonth: [
        { txt: "January", val: "january" },
        { txt: "February", val: "february" },
        { txt: "March", val: "march" },
        { txt: "April", val: "april" },
        { txt: "May", val: "may" },
        { txt: "June", val: "june" },
        { txt: "July", val: "july" },
        { txt: "August", val: "august" },
        { txt: "September", val: "september" },
        { txt: "October", val: "october" },
        { txt: "November", val: "november" },
        { txt: "December", val: "december" },
      ],
      headers: [
        {
          text: "ID",
          align: "start",
          value: "id",
        },
        {
          text: "NO TELADAN",
          align: "start",
          value: "data_scholar.no_tf",
        },
        {
          text: "Nama Scholar",
          align: "start",
          value: "data_scholar.name",
        },
        {
          text: "Review",
          align: "start",
          value: "content",
        },
        {
          text: "Status Review",
          align: "start",
          value: "status_draft",
        },
        { text: "Actions", sortable: false, value: "actions" },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/review/mentor/list/review?page[number]=${this.page}&page[size]=${this.limit}&sort=-created_at&filter[status_draft]=${this.status_draft}&include=dataMentor,dataScholar,dataCourse&filter[search]=${this.find}&filter[period_month]=${this.month}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    createReview() {
      this.d_type = "cm_review";
      this.d_title = "Create New Data";
      this.d_create = true;
    },
    updateReview(item) {
      this.inventory = item;
      this.d_type = "um_review";
      this.d_title = "Update Data";
      this.d_create = true;
    },
    viewReview(item) {
      this.inventory = item;
      this.d_type = "vm_review";
      this.d_title = "View Dassta";
      this.d_create = true;
    },
    deleteReview(item) {
      this.inventory = item;
      this.d_type = "dm_review";
      this.d_title = "Delete Data";
      this.d_small = true;
      item["d_width"] = "300px";
    },
    changeLimit(val) {
      this.limit = val;
      this.fetchData();
    },
  },
};
</script>

<style></style>
